import * as actionTypes from "constants/ActionTypes";
import {call, fork, put, take} from "redux-saga/effects";
import api from "services";

/**
 * Create preference
 * */
export function* createFilterAnnotationsPreference(data) {
    const response = yield call(api.createFilterAnnotationsPreference, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchCreateFilterAnnotationsPreference() {
    while (true) {
        const { data } = yield take(actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.REQUEST);
        yield fork(createFilterAnnotationsPreference, data);
    }
}

export default [
    watchCreateFilterAnnotationsPreference,
];



// WEBPACK FOOTER //
// ./app/sagas/preferences/filterAnnotations.js